<template>
    <div id="app">
      <!-- <keep-alive> 
        <div v-if="RouterState">
          <router-view v-if="$route.meta.keepAlive"></router-view> 
        </div>
      </keep-alive> 
      <router-view v-if="!$route.meta.keepAlive"></router-view> -->
      <router-view v-if="RouterState"></router-view> 
    </div>
</template>

<script>
  import $ from 'jquery'
  	import * as mUtils from 'utils/mUtils'
   import * as login from '@/api/login'
   	//  import * as imgUrl from '@/api/imgUrl'
    export default {
      name: 'App',
      provide() {
        return {
             
          reload: this.reload
        }
      },
      data() {
        return {
          windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
          RouterState: true
        };
      },
   created() {
      let that=this
//       	imgUrl.getDefaultUrl().then((res)=> {
						            
			
// 							if(res.data.code==1){
//  mUtils.setStore('imgUrl',res.data.data)
//               }
//         })
     
		},
       
    mounted() {
        var that = this;
        // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
              if(mUtils.getStore('lketg')){
              window.fullHeight = document.documentElement.clientHeight;
                window.fullWidth = document.documentElement.clientWidth;
                 that.windowHeight = window.fullHeight;  // 高
              that.windowWidth = window.fullWidth; // 宽
    // console.log(document.documentElement.clientHeight, document.documentElement.clientWidth)
          const win_size = {
				// width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
				width:that.windowWidth,
				height:that.windowHeight
			}
		
			//将content部分的宽高，存入store中，
			this.$store.dispatch('set_win_content',win_size);
              }else{
                     window.fullHeight = document.documentElement.clientHeight;
                window.fullWidth = document.documentElement.clientWidth-180;
                     that.windowHeight = window.fullHeight;  // 高
              that.windowWidth = window.fullWidth; // 宽
    // console.log(document.documentElement.clientHeight, document.documentElement.clientWidth)
          const win_size = {
				// width:(this.$store.state.menu.sidebar.opened)? this.$$lib_$(window).width()-180:this.$$lib_$(window).width()-35,
				width:that.windowWidth,
				height:that.windowHeight
			}
		
			//将content部分的宽高，存入store中，
			this.$store.dispatch('set_win_content',win_size);
              }
         
            })()
          };
    },
      methods: {

        reload() {
          this.RouterState = false;
          this.$nextTick(()=> {
            this.RouterState = true;
          } )
        }
      }
    }
</script>

<style lang="less">
	@import './style/element-ui';
	@import './style/font-awesome.min.css';
  @import './style/common';
</style>
 


// WEBPACK FOOTER //
// App.vue?08f8a598